import axios from "axios";
/**
 * Takes the Axios response and transforms it through an injected Zod Schema.
 *
 * Each call returns a new array holding a new function. axios-hooks compares
 * its config deeply but functions only by reference, so a config handed to
 * axios-hooks that calls this inline re-sends its request on every render.
 * Build it once at module level and refer to it from the config.
 */
export const parseAxiosResponse = (schema) => {
    return [
        // Run the default transformResponse functions first.
        // This will do stuff like parse the response as JSON.
        ...axios.defaults.transformResponse,
        // Now run the "success with content" response through the Zod schema.
        (data, _headers, status) => (status === 200 ? schema.parse(data) : data),
    ];
};
//# sourceMappingURL=helpers.js.map